import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"watermelon"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21.5 10.9882C21.5 16.7937 16.7937 21.5 10.9882 21.5C8.05725 21.5 4.40646 19.4349 2.5 17.5C5.21229 19.6345 8.98821 19.5 8.98821 19.5C14.7937 19.5 19.5 14.7937 19.5 8.98824C19.4882 9 19.6346 4.63455 17.5 2.5C19.435 4.40646 21.5 8.05726 21.5 10.9882Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17.5 2.5L2.5 17.5C5.21229 19.6345 8.98821 19.5 8.98821 19.5C14.7937 19.5 19.5 14.7937 19.5 8.98824C19.4882 9 19.6346 4.63455 17.5 2.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.5 2.5C19.435 4.40646 21.5 8.05726 21.5 10.9882C21.5 16.7937 16.7937 21.5 10.9882 21.5C8.05725 21.5 4.40646 19.4349 2.5 17.5L17.5 2.5ZM17.5 2.5C19.6346 4.63455 19.4882 9 19.5 8.98824C19.5 14.7937 14.7937 19.5 8.98821 19.5C8.98821 19.5 6.01494 19.6059 3.45 18.1383","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M9.50195 15.498H9.49805V15.502H9.50195V15.498Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M12.502 12.498H12.498V12.502H12.502V12.498Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15.502 9.49805H15.498V9.50195H15.502V9.49805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Watermelon = Vue.extend<IconProps>({
  name: 'WatermelonIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'watermelon',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Watermelon;
